import { Component, OnInit, Inject } from '@angular/core';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { OAuthService } from 'angular-oauth2-oidc';
import {Router} from '@angular/router';
import { ReportService } from '../../report.service';
import { NgZone } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { NxModalRef } from '@aposin/ng-aquila/modal';

@Component({
	selector: 'app-error-dialog',
	templateUrl: './error-dialog.component.html',
	styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent implements OnInit {
	showTechnicalError: boolean = false;
	showDetails: boolean = false;
	private timerSub?: Subscription;
	
	constructor(private oauthService: OAuthService, private reportService: ReportService,
		private router: Router, @Inject(NX_MODAL_DATA) readonly data: any,
		private ngZone: NgZone, private readonly modalRef: NxModalRef<ErrorDialogComponent>) {
		// if (data.errorCode === 'SESSION_LOST') {
			// if (!this.oauthService.hasValidAccessToken()) {				
			// 	data.message = 'Your session has expried! You will be relogin or redirected to login in 10 seconds.';
			// 	setTimeout(()=>{
			// 		this.relogin()
			// 	}, 10000);				
			// }
		// }
	}

	closeDialog(): void {
		// Optionally pass data back
		this.modalRef.close('Dialog closed programmatically');
	}

	ngOnInit(): void {
		// this.timerSub = timer(60000).subscribe(() => {
		// 	console.log('60 seconds passed! Triggering action...');
		// 	if (!this.oauthService.hasValidAccessToken()) {				
		// 		// data.message = 'Your session has expried! You will be relogin or redirected to login in 10 seconds.';
		// 		this.ngZone.run(() => {					
		// 			this.relogin()					
		// 		});
		// 	}
    	// });
		console.log('ErrorDialogComponent initialized with data:', this.data);
	}

	toggleTechnicalError() {
		this.showTechnicalError = !this.showTechnicalError;
	}

	getTrackerDetails(): string {
		return '';
	}

	toggleDetails() {
		this.showDetails = !this.showDetails;
	}

	public generateSendReport() {			
		  this.reportService.sendReport();	
		//   this.closeDialog();		  
	}

	logout(): void {
		this.oauthService.loadDiscoveryDocumentAndTryLogin()
		// this.oauthService.logOut(true);
		window.location.href = window.location.origin;
	}

	showRelogin(): boolean{
		return (
			this.data.errorCode === 'SESSION_LOST' ||
			!this.oauthService.hasValidAccessToken())
	}

	relogin() {
		console.error(`ErrorDialog.component before logout`);	
		this.oauthService.logOut();
		console.error(`ErrorDialog.component after logout`);	
		// console.log(`ErrorDialog.component before authentication`);
		// this.router.navigate(['/authentication']);
		console.log(`ErrorDialog.component before loadDiscoveryDocumentAndLogin`);					
		this.oauthService.loadDiscoveryDocumentAndLogin()
		console.log(`ErrorDialog.component after loadDiscoveryDocumentAndLogin`);					
		// console.error(`ErrorDialog.component after loadDiscoveryDocumentAndLogin`);	
		// this.oauthService.setupAutomaticSilentRefresh();
		// console.error(`ErrorDialog.component after setupAutomaticSilentRefresh`);	
	}

	reloginInTab() {
		console.error(`ErrorDialog.component before reloginInTab`);	
		this.closeDialog();
		window.open(`${window.location.origin}/dashboard`, '_blank');
		console.error(`ErrorDialog.component after reloginInTab`);	
	}	

}
